import React from "react";
import "./DecorativeBorder.css";

const DecorativeBorder = () => {
    return (
        <div className='decorative__border'/>
    );
}

export default DecorativeBorder;